export default __webpack_public_path__ + "static/media/Wollongong-2022.5cb9df39.jpg";